import { Box, TableHead, TableCell, TableRow, TableBody, Typography, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { AdvisorTitle } from "../components/AdvisorTitle";
import { useDealContext } from "../../deal/context";
import { useAdvisor } from "../context/AdvisorContext";
import { AdvisorTable } from "../../company/styles/AdvisorStyles";
import { IViewpoint, IFeedback, ITouchpoint, ViewpointStatus, TouchpointType } from "../../../types";
import dayjs from "dayjs";
import Loading from "../../../components/Loading";
import { ActiveAdvisors } from "../components/ActiveAdvisors";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ClientProvider from "../../../modules/ClientProvider";
import { AdvisorInsightsList } from "../components/insights/AdvisorInsightsList";
import { AdvisorFeedback } from "./AdvisorFeedback";

export const AdvisorInsights = () => {
    const { dealContext } = useDealContext();
    const { advisor, loading, fetchAdvisor } = useAdvisor();
    const project = dealContext.project;
    const viewerRole = dealContext.role;
    const [feedback, setFeedback] = useState<IFeedback[]>([]);
    const [feedbackLoading, setFeedbackLoading] = useState(false);
    const { getAccessTokenSilently } = useAuth0();

    const [touchpoints, setTouchpoints] = useState<ITouchpoint[]>([]);
    const [touchpointsLoading, setTouchpointsLoading] = useState(false);

    const fetchAdvisorTouchpoints = async () => {
        setTouchpointsLoading(true);
        const accessToken = await getAccessTokenSilently();
        const touchpointClient = ClientProvider.provideAdvisorTouchpointClient();
        const { data, error } = await touchpointClient.getAdvisorTouchpoints(project.tag, accessToken);
        if (data?.touchpoints) {
            setTouchpoints(data.touchpoints);
        }
        setTouchpointsLoading(false);
    };


    // Fetch advisor feedback when advisor is loaded
    useEffect(() => {
        const fetchAdvisorFeedback = async () => {
            if (advisor?.id && project?.tag) {
                setFeedbackLoading(true);
                try {
                    const accessToken = await getAccessTokenSilently();
                    const feedbackClient = ClientProvider.provideAdvisorFeedbackClient();
                    const { data, error } = await feedbackClient.getAdvisorFeedback(
                        project.tag, 
                        advisor.id, 
                        accessToken
                    );
                    if (data?.feedback) {
                        setFeedback(data.feedback);
                    }
                } catch (error) {
                    console.error('Error fetching advisor feedback:', error);
                } finally {
                    setFeedbackLoading(false);
                }
            }
        };

        fetchAdvisorFeedback();
        fetchAdvisorTouchpoints();
    }, [advisor?.id, project?.tag]);

    if (!project.insights_enabled) {
        return <AdvisorFeedback />
    }

    if (loading) {
        return <Loading />;
    }

    const completedTouchpoints = touchpoints.filter((touchpoint: ITouchpoint) => touchpoint?.viewpoints?.some((viewpoint: IViewpoint) => viewpoint?.advisor?.uuid === advisor?.uuid && viewpoint?.status && [ViewpointStatus.COMPLETED, ViewpointStatus.APPROVED].includes(viewpoint.status)));
    const newTouchpoints = advisor?.insights_enabled ? touchpoints.filter((touchpoint: ITouchpoint) => touchpoint?.status === "active" && touchpoint?.type !== TouchpointType.DEFAULT && !completedTouchpoints.some((completedTouchpoint: ITouchpoint) => completedTouchpoint?.uuid === touchpoint?.uuid)) : [];

    console.log("advisor", advisor);
    return (
        <Box>
            <AdvisorTitle project={project} section="Feedback" subheading={`React to product demos, participate in market surveys, and provide tips and insights along the way.`} />

            <Box sx={{ display: "flex", flexDirection: "row", gap: "40px" }}>
                <Stack direction="column" gap={2} sx={{ justifyContent: "flex-start", width: "100%", flexWrap: "wrap" }}>
                <Box sx={{ width: "100%", mb: 4 }}>
                    <Typography variant="body1" sx={{ fontWeight: "bold", fontSize: "1.1rem", margin: "1rem 0" }}>New</Typography>
                    <AdvisorInsightsList section="new" touchpoints={newTouchpoints} />
                </Box>
                <Box sx={{ width: "100%" }}>
                    <Typography variant="body1" sx={{ fontWeight: "bold", fontSize: "1.1rem", margin: "1rem 0" }}>Previous Questions</Typography>
                    <AdvisorInsightsList section="completed" touchpoints={completedTouchpoints} />
                </Box>
                </Stack>
                <Box sx={{ flex: "0 1 250px" }}>
                    <ActiveAdvisors advisor={advisor} project={project} />
                </Box>
            </Box>


        </Box>
    );
}